"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable no-underscore-dangle, no-plusplus */
if (!global.__MUI_PACKAGE_ID__) {
  global.__MUI_PACKAGE_ID__ = 0;
} // One unique value per @material-ui/core package installation.


var _default = global.__MUI_PACKAGE_ID__++;

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/styles/packageId.js
// module id = 963
// module chunks = 0